function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-944,-988.995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M960.887,1016.75L967.912,1009.72C968.401,1009.23 968.401,1008.45 967.912,1007.96C967.422,1007.47 966.637,1007.47 966.148,1007.96L961.254,1012.85L961.254,994.141C961.254,993.448 960.693,992.887 960,992.887C959.307,992.887 958.746,993.448 958.746,994.141L958.746,1012.84L953.852,1007.95C953.363,1007.46 952.577,1007.46 952.088,1007.95C951.599,1008.44 951.599,1009.22 952.088,1009.71L959.113,1016.74C959.358,1016.98 959.674,1017.1 960,1017.1C960.326,1017.1 960.642,1016.99 960.887,1016.75Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDownArrow);
export default __webpack_public_path__ + "static/media/scroll-down-arrow.14edcabe9ffd2230640c005e7496ebca.svg";
export { ForwardRef as ReactComponent };